module.exports = __webpack_public_path__ + "1273bee73db30d4f3951ce3bbe1524d0.pdf";